export const containerBoxStyle = {
  marginBlock: '2rem',
  marginInline: {
    xs: '1rem',
    sm: '2rem',
    lg: '3rem',
    xl: '5rem',
  },
};
